import { yupResolver } from '@hookform/resolvers/yup'
import { IconButton, Modal } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'
import Button from '../../../../components/button'
import TextField from '../../../../components/form/TextField'
import List from '../../../../components/list'
import { H4, Text } from '../../../../styles/typography'
import { InviteOthersEl } from '../elements'
import PricingStore from '../stores/pricing-store'

const InviteOthers = ({ close }) => {
  const {
    invites: { sent = [] } = {},
    deleteInvite,
    sendInvite,
  } = PricingStore.useContainer()

  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(
      object({
        email: string()
          .email('Enter a valid Email-ID')
          .required('Enter the Email-ID'),
      }),
    ),
  })

  const onSubmit = async ({ email }) => {
    const success = await sendInvite(email)

    if (success) {
      reset()
    }
  }

  return (
    <Modal open onClose={close}>
      <InviteOthersEl>
        <IconButton onClick={close} className='close'>
          <CloseIcon />
        </IconButton>
        <H4>Share your invite</H4>
        <Text>
          You can invite upto 5 other people for this same offer. Just enter
          their Email-ID to send them the invite.
        </Text>

        <Text>Invites sent:</Text>
        <List
          data={sent}
          defaultCount={5}
          item={({ email, id }, index) => (
            <Text className='sent-invite'>
              <span>
                {index + 1}. {email}
              </span>
              <IconButton onClick={() => deleteInvite(id)}>
                <DeleteIcon />
              </IconButton>
            </Text>
          )}
          noItemsMessage='No invitations sent yet.'
        />
        {sent?.length < 5 && (
          <div className='form'>
            <Text>Enter email to send invites:</Text>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TextField
                name='email'
                type='email'
                label='Email-ID'
                inputRef={register}
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
              <Button theme='primary' type='submit' disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Invite'}
              </Button>
            </form>
          </div>
        )}
      </InviteOthersEl>
    </Modal>
  )
}

export default InviteOthers

InviteOthers.propTypes = {
  close: PropTypes.func.isRequired,
}
